import { BrowserRouter, Route, Routes } from 'react-router-dom'
import AuthRoute from './Auth/AuthRoute';
import Login from './Auth/Login';
import AppContextProvider from './Context/AppContext';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Register from './Auth/Register';
import AdminLogin from './Auth/AdminLogin';
import ForgotPassword from './Auth/ForgetPassword';
import ResetPassword from './Auth/ResetPassword';
import GuestCancelBooKing from './Pages/HomeContainer/GuestCancelBooKing';


function App() {
 
  return (
    <>

      <AppContextProvider>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <BrowserRouter>
      
          <Routes>
            <Route path='/register' element={<Register />} />
            <Route path='/login' element={<Login />} />
            <Route path='/forgotPassword' element={<ForgotPassword />} />
            <Route path='/resetPassword/:token' element={<ResetPassword />} />
            <Route path='/admin' element={<AdminLogin />} />
            <Route path ="/cancel-guestbooking/:reference"  element={<GuestCancelBooKing/>} />
            <Route path='/*' element={<AuthRoute />} />
          </Routes>

        </BrowserRouter>

      </AppContextProvider>


    </>
  );
}

export default App;
